import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SavedState, savedFeatureKey } from './saved.reducer';

export const selectInstitutionsStoreState = createFeatureSelector<SavedState>(savedFeatureKey);

export const selectInstitutions = createSelector(
  selectInstitutionsStoreState,
  (state) => state.institutions || []
);
